// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1AJNY7","iconContainer":"_1BInNc","iconContainerVisited":"_17Ib7g","icon":"_20Va0k","preTitle":"_1KeeU_"};